const dragAndDrop = ({
        draggableElement = 'tr'
    } = {}) => {
    return {

        currentDragElement: null,

        dragStart() {
            this.currentDragElement = this.$el.closest(draggableElement);
            this.currentDragElement.setAttribute('this.currentDragElement', true);
        },

        dragEnter(event) {
            event.preventDefault();
        },

        dragOver(event) {
            event.preventDefault();
            const element = this.$el.closest(draggableElement);

            if (this.currentDragElement === element) {
                return;
            }

            const parent = element.parentNode;
            const siblings = Array.from(parent.children);
            const currentDragElementIndex = siblings.indexOf(this.currentDragElement);
            const elementIndex = siblings.indexOf(element);

            this.currentDragElement.style.opacity = 0;

            if (currentDragElementIndex < elementIndex) {
                parent.insertBefore(this.currentDragElement, element.nextSibling);

                return;
            }

            parent.insertBefore(this.currentDragElement, element);
        },

        drop({
            onDropFinished = (ids) => {}
        }) {
            this.currentDragElement.removeAttribute('this.currentDragElement');

            const parent = this.currentDragElement.parentNode;
            const element = this.$el.closest(draggableElement);

            parent.insertBefore(this.currentDragElement, element);

            const ids = Array.from(this.$root.querySelectorAll('[drag-item]'))
                .map(item => item.getAttribute('drag-item'));

            onDropFinished(ids);
        },

        dragEnd() {
            this.currentDragElement.removeAttribute('this.currentDragElement');
            this.currentDragElement.style.opacity = 1;
        },
    }
}

export default dragAndDrop;
